// extracted by mini-css-extract-plugin
export default {"form":"Login_form__iHhDl"};